import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="max-w-[96rem] mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16 border-thick-b" data-id="element-113">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-0" data-id="element-114">
        {/* Main Featured Story */}
        <motion.article initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="lg:col-span-8 group cursor-pointer lg:pr-12" data-id="element-115">
          <div className="mb-6" data-id="element-116">
            <span className="kicker-block mb-6" data-id="element-117">Essay</span>
            <h1 className="font-serif text-6xl sm:text-[7rem] lg:text-[9rem] xl:text-[10rem] leading-[0.85] font-black tracking-tighter mb-8 group-hover:text-accent transition-colors" data-id="element-118">
              The Quiet Collapse of the Regional Sports Network
            </h1>
          </div>

          <div className="aspect-[16/9] overflow-hidden mb-8 bg-ink border-2 border-ink" data-id="element-119">
            <img src="https://images.unsplash.com/photo-1459865264687-595d652de67e?q=80&w=2070&auto=format&fit=crop" alt="A stadium lit up at night ahead of a primetime broadcast" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 grayscale hover:grayscale-0" data-id="element-120" />
          </div>

          <p className="font-sans text-xl sm:text-2xl font-medium text-ink leading-snug mb-6 max-w-4xl" data-id="element-121">
            Bally's bankruptcy isn't a one-off. It's the end of the model that
            built modern team valuations — and the leagues that depend on it are
            quietly negotiating what comes next.
          </p>

          <div className="flex items-center space-x-3 font-mono text-sm uppercase tracking-widest" data-id="element-122">
            <span className="font-black text-ink" data-id="element-123">By Sarah Jenkins</span>
            <span className="text-ink font-black" data-id="element-124">/</span>
            <span className="text-ink font-bold" data-id="element-125">Oct 24, 2023</span>
          </div>
        </motion.article>

        {/* Secondary Stories */}
        <div className="lg:col-span-4 flex flex-col lg:border-thick-l" data-id="element-126">
          <motion.article initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2,
          ease: 'easeOut'
        }} className="group cursor-pointer flex flex-col gap-6 lg:pl-12 pb-12 border-thick-b lg:border-b-0 lg:border-thick-b" data-id="element-127">
            <div className="aspect-[4/3] overflow-hidden bg-ink border-2 border-ink shrink-0" data-id="element-128">
              <img src="https://images.unsplash.com/photo-1593766827228-8a8a4c4e2dee?q=80&w=1000&auto=format&fit=crop" alt="A broadcast microphone on a sports set" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 grayscale hover:grayscale-0" data-id="element-129" />
            </div>
            <div className="flex flex-col justify-center" data-id="element-130">
              <div className="mb-4" data-id="element-131">
                <span className="kicker-block" data-id="element-132">Field Note</span>
              </div>
              <h2 className="font-serif text-4xl sm:text-5xl leading-[0.9] font-black mb-4 group-hover:text-accent transition-colors tracking-tighter" data-id="element-133">
                Why Every Athlete Is Now a Media Company
              </h2>
              <div className="flex items-center space-x-2 font-mono text-xs uppercase tracking-widest mt-auto" data-id="element-134">
                <span className="font-black" data-id="element-135">By Marcus Chen</span>
              </div>
            </div>
          </motion.article>

          <motion.article initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3,
          ease: 'easeOut'
        }} className="group cursor-pointer flex flex-col gap-6 lg:pl-12 pt-12" data-id="element-136">
            <div className="aspect-[4/3] overflow-hidden bg-ink border-2 border-ink shrink-0" data-id="element-137">
              <img src="https://images.unsplash.com/photo-1577223625816-7546f13df25d?q=80&w=1000&auto=format&fit=crop" alt="A college basketball arena before tipoff" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 grayscale hover:grayscale-0" data-id="element-138" />
            </div>
            <div className="flex flex-col justify-center" data-id="element-139">
              <div className="mb-4" data-id="element-140">
                <span className="kicker-block" data-id="element-141">Essay</span>
              </div>
              <h2 className="font-serif text-4xl sm:text-5xl leading-[0.9] font-black mb-4 group-hover:text-accent transition-colors tracking-tighter" data-id="element-142">
                Inside the NIL Industrial Complex
              </h2>
              <div className="flex items-center space-x-2 font-mono text-xs uppercase tracking-widest mt-auto" data-id="element-143">
                <span className="font-black" data-id="element-144">By Elena Rostova</span>
              </div>
            </div>
          </motion.article>
        </div>
      </div>
    </section>;
}